

// const DealCard = ({ deal, onClick }) => {
//   return (
//     <div
//       className="rounded-3 overflow-hidden position-relative"
//       style={{ cursor: "pointer", aspectRatio: "4 / 3" }}  
//       onClick={onClick}
//     >
//       {/* Background image — poora card fill karegi */}
//       <img
//         src={`${process.env.REACT_APP_API}uploads/${deal.image}`}
//         alt={deal.title}
//         className="position-absolute top-0 start-0 w-100 h-100"
//         style={{ objectFit: "cover" }}
//       />

//       {/* Dark gradient — neeche se, taaki price/button readable rahe */}
//       <div
//         className="position-absolute bottom-0 start-0 w-100"
//         style={{
//           height: "55%",
//           background: "linear-gradient(to top, rgba(0,0,0,0.75) 0%, transparent 100%)",
//         }}
//       />

//       {/* Logo — top left */}
//       {deal.store_id?.logo && (
//         <img
//           src={`${process.env.REACT_APP_API}uploads/${deal.store_id.logo}`}
//           alt={deal.store_id.name}
//           className="position-absolute top-0 start-0 m-2 bg-white rounded p-1"
//           style={{ height: "32px", maxWidth: "80px", objectFit: "contain", zIndex: 2 }}
//         />
//       )}

//       {/* Discount % — top right */}
//       {deal.offer_percent > 0 && (
//         <span
//           className="badge bg-danger position-absolute top-0 end-0 m-2"
//           style={{ zIndex: 2 }}
//         >
//           -{deal.offer_percent}%
//         </span>
//       )}

//       {/* Bottom row — price left, button right, dono image ke andar */}
//       <div
//         className="position-absolute bottom-0 start-0 w-100 d-flex align-items-end justify-content-between p-2"
//         style={{ zIndex: 2 }}
//       >
//         <div>
//           {deal.price ? (
//             <div>
//               <span className="fw-bold text-white" style={{ fontSize: "15px" }}>
//                 ₹{deal.price}
//               </span>
//               {deal.mrp && (
//                 <span
//                   className="text-decoration-line-through ms-1"
//                   style={{ fontSize: "12px", color: "#ddd" }}
//                 >
//                   ₹{deal.mrp}
//                 </span>
//               )}
//             </div>
//           ) : (
//             deal.cashback_text && (
//               <span className="fw-semibold" style={{ fontSize: "13px", color: "#a5d6a7" }}>
//                 {deal.cashback_text}
//               </span>
//             )
//           )}
//         </div>

//         <button
//           className="text-white fw-semibold border-0"
//           style={{
//             background: "linear-gradient(135deg,#ff4b2b,#c01e12)",
//             borderRadius: "6px",
//             padding: "6px 14px",
//             fontSize: "12px",
//             whiteSpace: "nowrap",
//           }}
//           onClick={(e) => {
//             e.stopPropagation();
//             onClick();
//           }}
//         >
//              Grab Deal →
//         </button>
//       </div>
//     </div>
//   );
// };

// export default DealCard;

import DealImage from "./DealImage";

const DealCard = ({ deal, onClick }) => {
  return (
    <div
      className="rounded-3 overflow-hidden position-relative"
      style={{ cursor: "pointer", aspectRatio: "4 / 3" }}
      onClick={onClick}
    >
      {/* Background image fills the whole card; placeholder if it is missing */}
      <DealImage
        file={deal.image}
        alt={deal.title}
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{ objectFit: "cover" }}
      />

      {/* Dark gradient from the bottom so price/button stay readable */}
      <div
        className="position-absolute bottom-0 start-0 w-100"
        style={{
          height: "55%",
          background: "linear-gradient(to top, rgba(0,0,0,0.75) 0%, transparent 100%)",
          pointerEvents: "none",
        }}
      />

      {/* Store logo, top left (hidden if it fails to load) */}
      {deal.store_id?.logo && (
        <DealImage
          file={deal.store_id.logo}
          alt={deal.store_id.name}
          className="position-absolute top-0 start-0 m-2 bg-white rounded p-1"
          style={{ height: "32px", maxWidth: "80px", objectFit: "contain", zIndex: 2 }}
          hideOnError
        />
      )}

      {/* Discount %, top right */}
      {deal.offer_percent > 0 && (
        <span
          className="badge bg-danger position-absolute top-0 end-0 m-2"
          style={{ zIndex: 2 }}
        >
          -{deal.offer_percent}%
        </span>
      )}

      {/* Bottom row: price on the left, button on the right */}
      <div
        className="position-absolute bottom-0 start-0 w-100 d-flex align-items-end justify-content-between p-2"
        style={{ zIndex: 2 }}
      >
        <div>
          {deal.price ? (
            <div>
              <span className="fw-bold text-white" style={{ fontSize: "15px" }}>
                ₹{deal.price}
              </span>
              {deal.mrp && (
                <span
                  className="text-decoration-line-through ms-1"
                  style={{ fontSize: "12px", color: "#ddd" }}
                >
                  ₹{deal.mrp}
                </span>
              )}
            </div>
          ) : (
            deal.cashback_text && (
              <span className="fw-semibold" style={{ fontSize: "13px", color: "#a5d6a7" }}>
                {deal.cashback_text}
              </span>
            )
          )}
        </div>

        <button
          className="text-white fw-semibold border-0"
          style={{
            background: "linear-gradient(135deg,#ff4b2b,#c01e12)",
            borderRadius: "6px",
            padding: "6px 14px",
            fontSize: "12px",
            whiteSpace: "nowrap",
          }}
          onClick={(e) => {
            e.stopPropagation();
            onClick();
          }}
        >
          Grab Deal →
        </button>
      </div>
    </div>
  );
};

export default DealCard;